import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import PropTypesImmutable from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import {
  getClassifiersProductionTechnologyList,
  getClassifiersProductionTechnologyListData,
  getClassifiersProductionTechnologyDelete,
} from '../../reducers/classifiersReducer';
import {
  showProductionTechnologyEditModal,
  hideProductionTechnologyEditModal,
  getProductionTechnologyEditModal,
} from '../../actions/actionCreators/modalsActionCreators';
import { getLoadingSelector } from '../../utils/asyncHelpers';
import { Spin, Modal, Button } from 'antd';
import * as actions from '../../actions/actionCreators/classifiersActionCreators';
import { ProductionTechnologyTable, TableActions } from '../../components';
import { ProductionTechnologyEdit as ProductionTechnologyEditForm } from '../../forms';
import { goToClassifiers } from '../../utils/gotoLink';

const ProductionTechnologyList = ({
  t,
  loading,
  fetchClassifier,
  deleteClassifier,
  classifierData,
  modalVisible,
  hideModal,
  showModal,
}) => {
  const selectedCodeRef = useRef(null);

  useEffect(() => {
    fetchClassifier();
  }, [fetchClassifier]);

  const handleShowModal = (code = null) => {
    selectedCodeRef.current = code;
    showModal();
  };

  return (
    <Spin spinning={loading}>
      <h1>{t('productionTechnology')}</h1>
      {classifierData && (
        <ProductionTechnologyTable
          t={t}
          dataSource={classifierData.toJS()}
          deleteClassifier={deleteClassifier}
          showModal={handleShowModal}
        />
      )}
      {modalVisible && (
        <Modal
          title={t('productionTechnology')}
          open
          footer={null}
          onCancel={hideModal}
          width={640}
        >
          <ProductionTechnologyEditForm
            onCancel={hideModal}
            onComplete={hideModal}
            operatorCode={selectedCodeRef.current}
            t={t}
          />
        </Modal>
      )}
      <TableActions>
        <Button onClick={goToClassifiers}>{t('buttonBack')}</Button>
        <Button
          type="primary"
          onClick={() => handleShowModal(null)}
          className="global-margin-left-10"
        >
          {t('buttonValueAdd')}
        </Button>
      </TableActions>
    </Spin>
  );
};

ProductionTechnologyList.propTypes = {
  t: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  fetchClassifier: PropTypes.func.isRequired,
  deleteClassifier: PropTypes.func.isRequired,
  classifierData: PropTypesImmutable.list,
  modalVisible: PropTypes.bool.isRequired,
  hideModal: PropTypes.func.isRequired,
  showModal: PropTypes.func.isRequired,
};

const getIsLoading = getLoadingSelector(
  getClassifiersProductionTechnologyList,
  getClassifiersProductionTechnologyDelete
);

const mapStateToProps = (state) => ({
  loading: getIsLoading(state),
  classifierData: getClassifiersProductionTechnologyListData(state),
  modalVisible: getProductionTechnologyEditModal(state),
});

const mapDispatchToProps = (dispatch) => ({
  fetchClassifier: () => {
    dispatch(actions.fetchClassifierProductionTechnologyList());
  },
  deleteClassifier: async (code) => {
    await dispatch(actions.deleteClassifierProductionTechnology(code));
    dispatch(actions.fetchClassifierProductionTechnologyList());
  },
  showModal: () => {
    dispatch(showProductionTechnologyEditModal());
  },
  hideModal: () => {
    dispatch(hideProductionTechnologyEditModal());
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductionTechnologyList);
